exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".style__shape___3F8Zp{text-align:center}.style__group___1aD-c{display:flex;align-items:flex-end;margin-left:10px}.style__text___3vUWb{font-family:PlayfairDisplay-Regular;font-size:14px;letter-spacing:.4px}", ""]);

// exports
exports.locals = {
	"shape": "style__shape___3F8Zp",
	"group": "style__group___1aD-c",
	"text": "style__text___3vUWb"
};


//////////////////
// WEBPACK FOOTER
// ./~/css-loader?modules&localIdentName=[name]__[local]___[hash:base64:5]!./src/components/diamond-shapes/style.css
// module id = 685
// module chunks = 0